import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './ui/App';

const container = document.getElementById('root');
if (!container) throw new Error('Chýba #root element.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline režim (PWA). Registrujeme len v produkcii: počas vývoja by service worker
// držal v cache staré súbory a vývojár by „nevidel" svoje zmeny.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
      // Bez offline režimu appka funguje ďalej — je to nadstavba, nie podmienka.
    });
  });
}
